import * as useCases from './use-cases';

export const domainUseCases = useCases;

export default { useCases };
